var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutClearedStampStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Planned graduation completion stamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Red circular stamp with a dumbbell and completion check for steady planned progress.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#CC1111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 112,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 99,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 65,
    width: 86,
    height: 12,
    rx: 6,
    fill: "#CC1111",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 52,
    width: 21,
    height: 38,
    rx: 6,
    fill: "#CC1111",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 58,
    width: 14,
    height: 26,
    rx: 5,
    fill: "#CC1111",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 52,
    width: 21,
    height: 38,
    rx: 6,
    fill: "#CC1111",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 58,
    width: 14,
    height: 26,
    rx: 5,
    fill: "#CC1111",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 139 41 41 79-79",
    strokeWidth: 18,
    transform: "translate(38.4 38.4) scale(.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutClearedStampStandard);
export default __webpack_public_path__ + "static/media/workout_cleared_stamp_standard.aa7f98266415eff811afcc5547f2fdbd.svg";
export { ForwardRef as ReactComponent };